import Discount from "../../entities/discount";

/**
 * Discount actions
 *
 * Call order:
 *
 * DISCOUNT_SAVE_QUEUE:	adds the item to the save queue
 * --> DISCOUNT_SAVE:	modifies the state
 * --> DISCOUNT_SAVE_SUCCESS: if all went well
 * --> DISCOUNT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail DISCOUNT_SAVE_QUEUE is during the call to DISCOUNT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const DISCOUNT_FETCH_ONE_QUEUE: any = 'DISCOUNT_FETCH_ONE_QUEUE';
export const DISCOUNT_FETCH_SUCCESS: any = 'DISCOUNT_FETCH_SUCCESS';
export const DISCOUNT_FETCH_FAILURE: any = 'DISCOUNT_FETCH_FAILURE';
export const DISCOUNT_FETCH_ONE_SUCCESS: any = 'DISCOUNT_FETCH_ONE_SUCCESS';
export const DISCOUNT_FETCH_ONE_FAILURE: any = 'DISCOUNT_FETCH_ONE_FAILURE';

export const DISCOUNT_SAVE: any = 'DISCOUNT_SAVE';
export const DISCOUNT_SAVE_QUEUE: any = 'DISCOUNT_SAVE_QUEUE';
export const DISCOUNT_SAVE_SUCCESS: any = 'DISCOUNT_SAVE_SUCCESS';
export const DISCOUNT_SAVE_FAILURE: any = 'DISCOUNT_SAVE_FAILURE';

export const DISCOUNT_SAVE_MANY: any = 'DISCOUNT_SAVE_MANY';
export const DISCOUNT_SAVE_MANY_QUEUE: any = 'DISCOUNT_SAVE_MANY_QUEUE';
export const DISCOUNT_SAVE_MANY_SUCCESS: any = 'DISCOUNT_SAVE_MANY_SUCCESS';
export const DISCOUNT_SAVE_MANY_FAILURE: any = 'DISCOUNT_SAVE_MANY_FAILURE';

export const DISCOUNT_REMOVE: any = 'DISCOUNT_REMOVE';
export const DISCOUNT_REMOVE_QUEUE: any = 'DISCOUNT_REMOVE_QUEUE';
export const DISCOUNT_REMOVE_SUCCESS: any = 'DISCOUNT_REMOVE_SUCCESS';
export const DISCOUNT_REMOVE_FAILURE: any = 'DISCOUNT_REMOVE_FAILURE';

export const DISCOUNT_RESTORE: any = 'DISCOUNT_RESTORE';
export const DISCOUNT_RESTORE_QUEUE: any = 'DISCOUNT_RESTORE_QUEUE';
export const DISCOUNT_RESTORE_SUCCESS: any = 'DISCOUNT_RESTORE_SUCCESS';
export const DISCOUNT_RESTORE_FAILURE: any = 'DISCOUNT_RESTORE_FAILURE';

export const DISCOUNT_RESTORE_MANY: any = 'DISCOUNT_RESTORE_MANY';
export const DISCOUNT_REMOVE_MANY: any = 'DISCOUNT_REMOVE_MANY';

/* Fetch actions */
export const fetchDiscountSuccess = (discounts: Discount[], partial: boolean, lastFetch: number) => ({type: DISCOUNT_FETCH_SUCCESS, discounts, partial, lastFetch});
export const fetchDiscountFailure = (err: any) => {
		console.error('DiscountAction: fetchDiscountFailure', err);
		return {type: DISCOUNT_FETCH_FAILURE, err};
};
export const fetchOneDiscountQueue = (discountId: string) => ({type: DISCOUNT_FETCH_ONE_QUEUE, discountId});
export const fetchOneDiscountSuccess = (discount: Discount) => ({type: DISCOUNT_FETCH_ONE_SUCCESS, discount});
export const fetchOneDiscountFailure = (id: string, err: any) => {
		console.error('DiscountAction: fetchOneDiscountFailure', err);
		return {type: DISCOUNT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveDiscount = (discount: Discount) => {
    // console.debug('⮂ DISCOUNT_SAVE action', discount?.id);
    return {type: DISCOUNT_SAVE, discount};
}
export const saveDiscountQueue = (discount: Discount, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ DISCOUNT_SAVE_QUEUE action', discount?.id);
    return {type: DISCOUNT_SAVE_QUEUE, discount, onQueued};
}
export const saveDiscountSuccess = (discount: Discount) => {
    // console.debug('⮂ DISCOUNT_SAVE_SUCCESS action', discount?.id);
    return {type: DISCOUNT_SAVE_SUCCESS, discount};
}
export const saveDiscountFailure = (discount: Discount, status: number, message: string) => {
    console.warn(`⮂ DISCOUNT_SAVE_FAILURE error saving discount: HTTP ${status}: ${message}`, discount?.id);
    return {type: DISCOUNT_SAVE_FAILURE, discount, status, message};
};

/* SaveMany actions */
export const saveManyDiscounts = (discounts: Discount[]) => {
    // console.debug('⮂ DISCOUNT_SAVE_MANY action', discounts?.map(discount => discount?.id).join(','));
    return {type: DISCOUNT_SAVE_MANY, discounts};
}
export const saveManyDiscountsQueue = (discounts: Discount[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ DISCOUNT_SAVE_MANY_QUEUE action', discounts?.map(discount => discount.id).join(','));
    return {type: DISCOUNT_SAVE_MANY_QUEUE, discounts, onQueued};
}

export const saveManyDiscountsSuccess = (discounts: Discount[]) => {
    // console.debug('⮂ DISCOUNT_SAVE_MANY_SUCCESS action', discounts?.map(discount => discount.id).join(','));
    return {type: DISCOUNT_SAVE_MANY_SUCCESS, discounts};
}
export const saveManyDiscountsFailure = (discounts: Discount[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_DISCOUNTS_FAILURE Error saving discounts: HTTP ${status}: ${message}`, discounts?.map(discount => discount.id).join(','));
		return {type: DISCOUNT_SAVE_MANY_FAILURE, discounts, status, message};
};

/* Remove actions */
export const removeDiscount = (discount: Discount) => ({ type: DISCOUNT_REMOVE, discount });
export const removeDiscountQueue = (discount: Discount) => ({ type: DISCOUNT_REMOVE_QUEUE, discount });
export const removeDiscountSuccess = (discount: Discount) => ({ type: DISCOUNT_REMOVE_SUCCESS, discount });
export const removeDiscountFailure = (discount: Discount, status: number, message: string) => {
	console.error(`Redux: removeDiscountFailure Error removing discount: HTTP ${status}: ${message}`);
	return ({ type: DISCOUNT_REMOVE_FAILURE, discount, status, message });
};

/* Restore actions */
export const restoreDiscount = (discount: Discount) => ({ type: DISCOUNT_RESTORE, discount });
export const restoreDiscountQueue = (discount: Discount) => ({ type: DISCOUNT_RESTORE_QUEUE, discount });
export const restoreDiscountSuccess = (discount: Discount) => ({ type: DISCOUNT_RESTORE_SUCCESS, discount });
export const restoreDiscountFailure = (discount: Discount, status: number, message: string) => {
	console.error(`Redux: restoreDiscountFailure Error restoring discount: HTTP ${status}: ${message}`);
	return ({ type: DISCOUNT_RESTORE_FAILURE, discount, status, message });
};

/* RestoreMany actions */
export const restoreManyDiscounts = (discounts: Discount[]) => ({ type: DISCOUNT_RESTORE_MANY, discounts });

/* RemoveMany actions */
export const removeManyDiscounts = (discounts: Discount[]) => ({ type: DISCOUNT_REMOVE_MANY, discounts });